export default async function fetchWithTimeout(resource, options = {}) {
  const { timeout = 3000 } = options

  const controller = new AbortController()
  const id = setTimeout(() => {
    console.log(`fetchWithTimeout: Aborting request to ${resource} timeout after ${timeout}ms`)
    controller.abort()
  }, timeout)
  console.log(`fetchWithTimeout: Fetching ${resource} starting`)
  const startTime = Date.now()
  const response = await fetch(resource, {
    headers: {
      ["x-api-key"]: "162C7D559DE4DD383DFD9867A456D8AA"
    },
    ...options,
    signal: controller.signal
  })
  const duration = Date.now() - startTime
  console.log(`fetchWithTimeout: Fetching ${resource} took ${duration}ms`)
  clearTimeout(id)
  return response
}
